import type { ReactNode } from "react";

type Tone = "light" | "soft" | "mint" | "plain";

const PANEL: Record<Tone, string> = {
  light: "panel-light",
  soft: "panel-soft",
  mint: "panel-mint",
  plain: "panel-plain",
};

/**
 * Sección con panel: el mismo bloque que usa el home (etiqueta, título en
 * pregunta, respuesta corta y contenido). Se usa en TODAS las páginas para que
 * el ritmo vertical y los títulos queden alineados en todo el sitio.
 */
export function PanelSection({
  tone = "light",
  eyebrow,
  title,
  answer,
  label,
  as = "section",
  children,
}: {
  tone?: Tone;
  eyebrow?: string;
  title?: string;
  answer?: ReactNode;
  /** aria-label de la sección; por defecto usa el título */
  label?: string;
  as?: "section" | "nav";
  children?: ReactNode;
}) {
  const Tag = as;
  return (
    <Tag className="section-air" aria-label={label ?? title}>
      <div className="container-site">
        <div className={PANEL[tone]}>
          {eyebrow ? <span className="panel-eyebrow">{eyebrow}</span> : null}
          {title ? <h2 className="h-panel">{title}</h2> : null}
          {answer ? <p className="answer-first">{answer}</p> : null}
          {children}
        </div>
      </div>
    </Tag>
  );
}
